import { Inject, Injectable } from '@angular/core';
import { PRODUCTS_SERVICE_URL } from 'src/app/injection-tokens';
import { HttpClient } from '@angular/common/http';
import { map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Stats } from '../suppliers/supplier';
import { TUSpecial } from './tu-special';

export interface TUCombinedData {
  specials: TUSpecial[];
  stats: Stats;
}

@Injectable({
  providedIn: 'root',
})
export class TUSpecialsService {
  readonly serviceURL: string;

  constructor(
    @Inject(PRODUCTS_SERVICE_URL) readonly baseServiceURL: string,
    readonly http: HttpClient
  ) {
    this.serviceURL = baseServiceURL + '/specials';
  }

  getCombinedData(): Observable<TUCombinedData> {
    // Sequential on purpose: Firefox aborts parallel requests to the VPN-only API hosts,
    // see "Parallel requests to private API hosts" in AGENTS.md.
    return this.getTUSpecials().pipe(
      switchMap(specials => this.getTUStats().pipe(map(stats => ({ specials, stats }))))
    );
  }

  createTUSpecial(special: TUSpecial): Observable<TUSpecial> {
    return this.http.post<TUSpecial>(this.serviceURL + '/tu', special);
  }

  getTUSpecial(id: number): Observable<TUSpecial> {
    return this.http.get<TUSpecial>(`${this.serviceURL}/tu/${id.toString()}`);
  }

  getTUStats(): Observable<Stats> {
    return this.http.get<Stats>(`${this.serviceURL}/tu/stats`);
  }

  getTUSpecials(): Observable<TUSpecial[]> {
    return this.http.get<TUSpecial[]>(this.serviceURL + '/tu');
  }
}
